"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakpoint = void 0;
var Breakpoint;
(function (Breakpoint) {
    Breakpoint["Mobile"] = "420px";
    Breakpoint["Tablet"] = "768px";
    Breakpoint["Desktop"] = "1024px";
    Breakpoint["LargeDesktop"] = "1440px";
    Breakpoint["ExtraLargeDesktop"] = "1920px";
})(Breakpoint = exports.Breakpoint || (exports.Breakpoint = {}));
